import { render, staticRenderFns } from "./ConfirmSensitiveContent.vue?vue&type=template&id=7f82e41d&"
import script from "./ConfirmSensitiveContent.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSensitiveContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports